"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_1 = require("@completeanatomy/ui");
const styled_components_1 = __importStar(require("styled-components"));
function TitleSubtitleDiversity({ title, subtitle, $isList, }) {
    return ((0, jsx_runtime_1.jsx)(TextContainer, { "data-e2e": 'TitleSubtitleDiversity_TextContainer', children: (0, jsx_runtime_1.jsxs)(Titles, { "data-e2e": 'TitleSubtitleDiversity_Titles', children: [(0, jsx_runtime_1.jsx)(Title, { "data-e2e": 'TitleSubtitleDiversity_Title', children: title }), (0, jsx_runtime_1.jsx)(Subtitle, { "$isList": $isList, "data-e2e": 'TitleSubtitleDiversity_Subtitle', children: (0, jsx_runtime_1.jsx)("ul", { "data-e2e": 'TitleSubtitleDiversity_ul', children: subtitle.map((listItem, i) => ((0, jsx_runtime_1.jsx)(ListItem, { "data-e2e": 'TitleSubtitleDiversity_ListItem', children: listItem }, i))) }) })] }) }));
}
exports.default = TitleSubtitleDiversity;
const TextContainer = styled_components_1.default.div `
  position: relative;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 45vw;

  ${ui_1.devicePortrait.mobileS((0, styled_components_1.css) `
    width: 100vw;
  `)};

  ${ui_1.deviceLandscape.laptopS((0, styled_components_1.css) `
    position: static;
    justify-content: flex-start;
    width: 100vw;
    height: 18vh;
  `)};
`;
const Titles = styled_components_1.default.div `
  ${ui_1.devicePortrait.tablet((0, styled_components_1.css) `
    height: 30vh;
    margin-bottom: 20px;
  `)};
`;
const Title = styled_components_1.default.div `
  margin: 0 40px;
  padding: 0 20px;

  color: ${({ theme }) => theme.modelsPanel.title};

  font-weight: 400;
  font-size: 24px;

  line-height: 30px;
  text-align: center;

  ${ui_1.devicePortrait.tablet((0, styled_components_1.css) `
    margin: 48px auto 8px auto;
  `)};

  ${ui_1.deviceLandscape.mobileM((0, styled_components_1.css) `
    margin: 48px 19px 0 12px;
    padding: 0;
  `)};

  ${ui_1.deviceLandscape.tablet((0, styled_components_1.css) `
    margin: 48px 42px 0;
  `)};

  ${ui_1.deviceLandscape.laptopS((0, styled_components_1.css) `
    justify-content: flex-start;

    margin: 24px 60px 0;
    padding: 0 30px;
  `)};

  ${ui_1.deviceLandscape.laptop((0, styled_components_1.css) `
    margin: 48px 60px 0;
  `)};
`;
const Subtitle = styled_components_1.default.div `
  margin: 16px 40px 8px;

  color: ${({ theme }) => theme.settings.text};

  font-weight: 400;
  font-size: 16px;

  line-height: 24px;
  text-align: center;

  ${ui_1.devicePortrait.tablet((0, styled_components_1.css) `
    width: 722px;
  `)};

  ${ui_1.deviceLandscape.mobileS((0, styled_components_1.css) `
    margin: 12px 19px 15px 12px;
  `)};

  ${ui_1.deviceLandscape.tablet((0, styled_components_1.css) `
    margin: 16px 30px 20px;
  `)};

  ${ui_1.deviceLandscape.laptopS((0, styled_components_1.css) `
    margin: 8px auto;
    width: 722px;
  `)};

  & ul {
    padding: 0;
  }
  li {
    list-style-type: ${props => (props.$isList ? 'disc' : 'none')};
  }
`;
const ListItem = styled_components_1.default.li `
  list-style: inside;
`;
